<template>
    <div class="moon">
    <div class="earthShadow" :style="eStyle">
    </div>
    </div>
</template>
<script>
import math from './mixins/math'
export default {
    mixins: [math],
    computed:{
        eStyle: function(){
            return{
                "margin-left": this.randomRange(10,25) + 'px'
            }
        }
    }
}
</script>
<style scoped>
.moon{
  width: 50px;
  height: 50px;
  border-radius: 100%;
  border: 0px;
  background-color: #e0eff5;
  position: absolute;
  margin-left: 100px;
  margin-top: 50px;
}
.earthShadow{
  width: 50px;
  height: 50px;
  border-radius: 100%;
  background-color: rgb(6, 2, 68);
  position: absolute;
}
</style>